import { mapGetters } from 'vuex';
import loaderMixin from '@/mixins/loader';
import sessionHistorySushi from '@/components/session-history-sushi/session-history-sushi.vue';
import productHistorySushi from '@/components/product-history-sushi/product-history-sushi.vue';
import watchlistSushi from '@/components/watchlist-sushi/watchlist-sushi.vue';
import disqusMixin from '@/mixins/disqus';

const MODAL_OPEN_CLASS = 'modal-open';

const SECTIONS = {
  DISCUSSION: 'discussion',
  WATCHLIST: 'watchlist',
  SESSION_HISTORY: 'session-history',
  PRODUCT_HISTORY: 'product-history',
};

export default {
  mixins: [
    loaderMixin,
    disqusMixin,
  ],
  props: {
    market: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      opened: null,
      SECTIONS,
    }
  },
  components: {
    sessionHistorySushi,
    productHistorySushi,
    watchlistSushi,
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    sections() {
      const results = [];
      if (this.market.disqus_Identifier) {
        results.push({ name: SECTIONS.DISCUSSION, title: 'Discussion' });
      }
      if (this.isLoggedIn) {
        return [
          ...results,
          { name: SECTIONS.WATCHLIST, title: 'Watchlist' },
          { name: SECTIONS.SESSION_HISTORY, title: 'Session' },
        ]
      }
      return [
        ...results,
        { name: SECTIONS.SESSION_HISTORY, title: 'Session' },
      ];
    },
  },
  methods: {
    openSection(section) {
      this.opened = section;
      document.documentElement.classList.add(MODAL_OPEN_CLASS);
      document.body.classList.add(MODAL_OPEN_CLASS);
    },
    closeSection() {
      this.opened = null;
      document.documentElement.classList.remove(MODAL_OPEN_CLASS);
      document.body.classList.remove(MODAL_OPEN_CLASS);
    },
  },
  beforeDestroy() {
    document.documentElement.classList.remove(MODAL_OPEN_CLASS);
    document.body.classList.remove(MODAL_OPEN_CLASS);
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/bottom-market-links-widget/bottom-market-links-widget.js